declare global {
  function gettext(msgid: string): string;
  function ngettext(singular: string, plural: string, count: number): string;
  function interpolate(fmt: string, obj: Record<string, string | number>, named: boolean): string;
  function interpolate(fmt: string, arr: (string | number)[]): string;
}

export const t = gettext;
export const tn = ngettext;
export const fmt = (template: string, values: Record<string, string | number>): string =>
  interpolate(gettext(template), values, true);

/**
 * Returns the BCP 47 locale tag from the <html lang> attribute,
 * which Django sets to the user's active language (e.g. "en", "zh-Hant").
 * Falls back to undefined so Intl APIs use the browser default.
 */
export function getAppLocale(): string | undefined {
  return document.documentElement.lang || undefined;
}
